import {createClient} from '@sanity/client'

export const sanityClient = createClient({
  projectId: '4b0vchfj',
  dataset: 'production',
  useCdn: true, // set to `false` to bypass the edge cache
})